<template>
  <div class="fego-dashboard">
    <!-- نفس السايدبار -->
    <div class="sidebar">
      <sidebarComponent />
    </div>

    <div class="main-content">
      <!-- الهيدر/التوب بار -->
      <WaitingDriversNumber :waiting-captains="waitingCaptains" />

      <div class="card">
        <h2 class="section-title">Offers Management</h2>

        <!-- Create / Edit Offer Form -->
        <div class="grid-2">
          <div class="form-card">
            <h3>{{ editingId ? "Update Offer" : "Create Offer" }}</h3>

            <label>Type</label>
            <select v-model="form.offerType">
              <option value="user">user</option>
              <option value="driver">driver</option>
            </select>

            <label>Message</label>
            <input v-model="form.message" placeholder="Offer message" />

            <div class="grid-3">
              <div>
                <label>Reward (EGP)</label>
                <input type="number" v-model.number="form.reward" min="0" />
              </div>
              <div>
                <label># Trips</label>
                <input
                  type="number"
                  v-model.number="form.numberOfTrips"
                  min="1"
                />
              </div>
            </div>

            <div class="grid-2">
              <div>
                <label>Start Date</label>
                <input type="date" v-model="form.startDate" />
                <small class="hint" v-if="form.startDate">
                  {{ displayDate(form.startDate) }}
                </small>
              </div>
              <div>
                <label>End Date</label>
                <input type="date" v-model="form.endDate" />
                <small class="hint" v-if="form.endDate">
                  {{ displayDate(form.endDate) }}
                </small>
              </div>
            </div>

            <label>Winner Message</label>
            <input v-model="form.winnerMessage" placeholder="Winner message" />

            <div class="actions">
              <button @click="submitForm">
                {{ editingId ? "Update" : "Create" }}
              </button>
              <button v-if="editingId" class="secondary" @click="resetForm">
                Cancel
              </button>
              <button class="secondary" @click="editActiveOffer">
                Edit Active
              </button>
            </div>
          </div>
        </div>

        <!-- Offers List -->
        <div class="list-card">
          <h3>Offers</h3>

          <div class="toolbar">
            <label>Page</label>
            <input
              type="number"
              v-model.number="page"
              min="1"
              @change="fetchOffers"
            />
            <label>Limit</label>
            <input
              type="number"
              v-model.number="limit"
              min="1"
              @change="fetchOffers"
            />
            <button class="secondary" @click="fetchOffers">Reload</button>
          </div>

          <div v-if="offers.length === 0" class="empty">No offers</div>

          <div v-for="offer in offers" :key="offer._id" class="offer-row">
            <div class="offer-info">
              <div class="title">
                {{ offer.offerType === "user" ? "User Offer" : "Driver Offer" }}
                • {{ offer.numberOfTrips }} trips • {{ offer.reward }} EGP
              </div>
              <div class="sub">
                {{ displayDate(offer.startDate) }} →
                {{ displayDate(offer.endDate) }}
              </div>
              <div class="msg">{{ offer.message }}</div>
            </div>

            <div class="row-actions">
              <button class="secondary" @click="editOffer(offer)">Edit</button>

              <button
                class="danger"
                :disabled="!isActiveOffer(offer)"
                @click="isActiveOffer(offer) && expireOffer(offer)"
              >
                Expire ({{ displayDate(offer.endDate) }})
              </button>

              <button class="danger" @click="deleteOffer(offer)">Delete</button>
              <button class="secondary ghost" @click="viewWinners(offer)">
                Winners
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Winners Modal -->
      <div v-if="showWinners" class="modal-backdrop" @click.self="closeWinners">
        <div class="modal">
          <h3>
            Winners –
            {{ currentOffer?.offerType === "driver" ? "Driver" : "User" }}
          </h3>
          <p class="sub" v-if="currentOffer">
            {{ displayDate(currentOffer.startDate) }} →
            {{ displayDate(currentOffer.endDate) }}
          </p>

          <!-- يظهر دايمًا على الأقل حالة واحدة -->
          <div v-if="winnersLoading" class="empty">Loading…</div>
          <div v-else-if="winnersError" class="empty">
            Error: {{ winnersError }}
          </div>
          <div v-else-if="!winners || winners.length === 0" class="empty">
            لا يوجد فائزون حتى الآن.
          </div>

          <div v-else>
            <div v-for="w in winners" :key="w._id" class="winner-row">
              <div class="winner-main">
                <strong>{{
                  w.username || w.email || w.phoneNumber || w._id
                }}</strong>
                <small v-if="w.email"> · {{ w.email }}</small>
                <small v-if="w.phoneNumber"> · {{ w.phoneNumber }}</small>
              </div>
              <div class="winner-wallet">Wallet: {{ w.wallet ?? 0 }}</div>
            </div>
          </div>

          <button class="secondary" @click="closeWinners">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import sidebarComponent from "@/components/sidebarComponent.vue";
import WaitingDriversNumber from "@/components/waitingDriversNumber.vue";

const BASE_URL = "https://backend.fego-rides.com";
// لو قائمتك على /offers/getAll بدّلي السطر الجاي
const LIST_ENDPOINT = "/offers";

export default {
  name: "OffersManager",
  components: { sidebarComponent, WaitingDriversNumber },
  data() {
    return {
      waitingCaptains: 0,

      // list state
      offers: [],
      page: 1,
      limit: 10,

      // form state
      editingId: null,
      form: {
        message: "",
        offerType: "user",
        reward: 0,
        numberOfTrips: 1,
        startDate: "",
        endDate: "",
        winnerMessage: "",
      },

      // winners modal state
      showWinners: false,
      winnersLoading: false,
      winnersError: "",
      currentOffer: null,
      winners: [],
    };
  },
  created() {
    this.fetchOffers();
  },
  methods: {
    // ---------- Date helpers ----------
    toApiDate(isoDate) {
      if (!isoDate) return "";
      const [y, m, d] = isoDate.split("-");
      return `${d}-${m}-${y}`; // DD-MM-YYYY
    },
    toInputDate(apiDate) {
      if (!apiDate) return "";
      if (apiDate.includes("T")) return apiDate.slice(0, 10);
      const sep = apiDate.includes("/")
        ? "/"
        : apiDate.includes("-")
        ? "-"
        : null;
      if (!sep) return "";
      const [d, m, y] = apiDate.split(sep);
      if (!d || !m || !y) return "";
      return `${y.padStart(4, "0")}-${m.padStart(2, "0")}-${d.padStart(
        2,
        "0"
      )}`;
    },
    parseApiDate(anyDate) {
      if (!anyDate) return null;
      if (anyDate.includes("T")) return new Date(anyDate);
      const sep = anyDate.includes("/") ? "/" : "-";
      const [d, m, y] = anyDate.split(sep);
      if (!d || !m || !y) return null;
      return new Date(`${y}-${m}-${d}T00:00:00`);
    },
    toDateObj(isoDate) {
      return isoDate ? new Date(`${isoDate}T00:00:00`) : null;
    },
    displayDate(anyDate) {
      if (!anyDate) return "";
      if (anyDate.includes("T")) {
        const [y, m, d] = anyDate.slice(0, 10).split("-");
        return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
      }
      const sep = anyDate.includes("/") ? "/" : "-";
      const parts = anyDate.split(sep);
      if (parts[0].length === 4) {
        const [y, m, d] = parts;
        return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
      }
      const [d, m, y] = parts;
      return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
    },
    isoYesterday() {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      return d.toISOString().slice(0, 10);
    },

    // ---------- State helpers ----------
    isActiveOffer(offer) {
      const start = this.parseApiDate(offer.startDate);
      const end = this.parseApiDate(offer.endDate);
      if (!start || !end) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today >= start && today <= end;
    },
    cmpByEndThenCreatedDesc(a, b) {
      const aEnd = this.parseApiDate(a.endDate)?.getTime() || 0;
      const bEnd = this.parseApiDate(b.endDate)?.getTime() || 0;
      if (aEnd !== bEnd) return bEnd - aEnd;
      const aCreated = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bCreated = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return bCreated - aCreated;
    },

    // ---------- CRUD ----------
    async fetchOffers() {
      try {
        const { data } = await axios.get(`${BASE_URL}${LIST_ENDPOINT}`, {
          params: { page: this.page, limit: this.limit, _t: Date.now() },
          headers: { "Cache-Control": "no-cache" },
        });
        this.offers = data.offers || data || [];
      } catch (e) {
        alert(
          "Failed to load offers: " + (e.response?.data?.message || e.message)
        );
      }
    },
    async deleteOffer(offer) {
      try {
        const ok = confirm(
          `هتمسح العرض ده نهائيًا؟\n\n` +
            `نوع: ${offer.offerType}\n` +
            `رحلات: ${offer.numberOfTrips}\n` +
            `مكافأة: ${offer.reward} EGP`
        );
        if (!ok) return;
        await axios.delete(`${BASE_URL}/offers/${offer._id}`);
        alert("تم حذف العرض بنجاح.");
        await this.fetchOffers();
      } catch (e) {
        alert("Delete failed: " + (e.response?.data?.message || e.message));
      }
    },

    async viewWinners(offer) {
      // افتح المودال فوراً
      this.showWinners = true;
      this.winnersLoading = true;
      this.winnersError = "";
      this.currentOffer = offer;
      this.winners = [];

      try {
        const url = `${BASE_URL}/offers/getOne/${offer._id}`;

        // التوكن
        const rawToken =
          localStorage.getItem("token") ||
          localStorage.getItem("accessToken") ||
          localStorage.getItem("adminToken") ||
          sessionStorage.getItem("token") ||
          sessionStorage.getItem("accessToken") ||
          sessionStorage.getItem("adminToken") ||
          "";

        const headers = rawToken
          ? { token: `Bearer ${rawToken}`, Authorization: `Bearer ${rawToken}` }
          : {};

        const { data } = await axios.get(url, { headers });

        const details = data.offer || data;
        this.currentOffer = details;
        this.winners = Array.isArray(details.winners) ? details.winners : [];
      } catch (e) {
        this.winnersError =
          e?.response?.data?.message || e.message || "Unknown error";
      } finally {
        this.winnersLoading = false;
      }
    },
    closeWinners() {
      this.showWinners = false;
      this.currentOffer = null;
      this.winners = [];
      this.winnersError = "";
    },

    // ---------- Validation & form ----------
    validateForm() {
      const f = this.form;
      f.message = (f.message || "").trim();
      f.winnerMessage = (f.winnerMessage || "").trim();

      if (!["user", "driver"].includes(f.offerType))
        throw new Error("offerType invalid");
      if (!f.message) throw new Error("message is required");
      if (!f.winnerMessage) throw new Error("winnerMessage is required");

      if (Number(f.reward) < 0) throw new Error("reward must be >= 0");
      if (!(Number(f.numberOfTrips) >= 1))
        throw new Error("numberOfTrips must be >= 1");

      if (!f.startDate || !f.endDate) throw new Error("dates are required");

      const start = this.toDateObj(f.startDate);
      const end = this.toDateObj(f.endDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (end <= start) throw new Error("endDate must be after startDate");
      if (end <= today) throw new Error("endDate must be after today");
    },
    resetForm() {
      this.editingId = null;
      this.form = {
        message: "",
        offerType: "user",
        reward: 0,
        numberOfTrips: 1,
        startDate: "",
        endDate: "",
        winnerMessage: "",
      };
    },
    async submitForm() {
      try {
        this.validateForm();
        const payload = {
          message: this.form.message,
          offerType: this.form.offerType,
          reward: Number(this.form.reward),
          numberOfTrips: Number(this.form.numberOfTrips),
          startDate: this.toApiDate(this.form.startDate),
          endDate: this.toApiDate(this.form.endDate),
          winnerMessage: this.form.winnerMessage,
        };

        if (this.editingId) {
          await axios.patch(`${BASE_URL}/offers/${this.editingId}`, payload);
          alert("Offer updated successfully!");
        } else {
          await axios.post(`${BASE_URL}/offers`, payload);
          alert("Offer created successfully!");
        }

        this.resetForm();
        await this.fetchOffers();
      } catch (e) {
        const msg = e?.response?.data?.message || e.message || "Unknown error";
        console.error("Create/Update failed:", msg);

        if (/active offer already exists/i.test(msg)) {
          try {
            const candidate = await this.findActiveOrLatestOfType(
              this.form.offerType
            );
            if (candidate) {
              this.editOffer(candidate);
              const note = this.isActiveOffer(candidate)
                ? "يوجد أوفر نشط لهذا النوع؛ تم تحميله للتعديل."
                : "لا يوجد أوفر نشّط؛ تم تحميل أحدث أوفر لهذا النوع للتعديل.";
              alert(note);
            } else {
              alert("لا يوجد أي أوفر لهذا النوع حتى الآن.");
            }
          } catch {
            alert("تعذّر تحديد الأوفر المناسب لهذا النوع.");
          }
        } else {
          alert("Create/Update failed: " + msg);
        }
      }
    },
    async editActiveOffer() {
      try {
        const type = this.form.offerType;
        const candidate = await this.findActiveOrLatestOfType(type);
        if (!candidate) return alert(`لا يوجد أي أوفر لنوع ${type}.`);

        this.editOffer(candidate);
        const msg = this.isActiveOffer(candidate)
          ? "تم تحميل الأوفر النشّط للتعديل."
          : "لا يوجد أوفر نشّط؛ تم تحميل أحدث أوفر لهذا النوع للتعديل.";
        alert(msg);
      } catch (e) {
        console.error("editActiveOffer error:", e);
        alert("تعذّر جلب الأوفر.");
      }
    },
    editOffer(offer) {
      this.editingId = offer._id;
      this.form = {
        message: offer.message || "",
        offerType: offer.offerType || "user",
        reward: Number(offer.reward ?? 0),
        numberOfTrips: Number(offer.numberOfTrips ?? 1),
        startDate: this.toInputDate(offer.startDate),
        endDate: this.toInputDate(offer.endDate),
        winnerMessage: offer.winnerMessage || "",
      };
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async expireOffer(offer) {
      try {
        // هات النسخة الكاملة (بعض السيرفرات تشترط إرسال كل الحقول)
        const { data } = await axios.get(
          `${BASE_URL}/offers/getOne/${offer._id}`
        );
        const full = data.offer || data;

        const yISO = this.isoYesterday(); // YYYY-MM-DD
        const endDateDDMMYYYY = (() => {
          const [y, m, d] = yISO.split("-");
          return `${d}/${m}/${y}`; // للعرض في الـ UI
        })();

        const payload = {
          message: full.message,
          offerType: full.offerType,
          reward: Number(full.reward ?? 0),
          numberOfTrips: Number(full.numberOfTrips ?? 1),
          startDate: this.toApiDate(this.toInputDate(full.startDate)),
          endDate: this.toApiDate(yISO), // DD-MM-YYYY للإرسال
          winnerMessage: full.winnerMessage || "",
        };

        await axios.patch(`${BASE_URL}/offers/${offer._id}`, payload);

        // تحديث فوري للـ UI
        offer.endDate = endDateDDMMYYYY;

        alert("تم إنهاء العرض: endDate = أمس.");
        await this.fetchOffers();
      } catch (e) {
        alert("Expire failed: " + (e.response?.data?.message || e.message));
      }
    },
  },
};
</script>

<style scoped>
.fego-dashboard {
  display: flex;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}
.sidebar {
  width: 250px;
  background: #6b5b95;
  color: #fff;
  padding: 20px;
}
.main-content {
  flex: 1;
  padding: 30px;
  background: #f5f7fa;
}

.card {
  background: #fff;
  border: 2px solid #8e44ad;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.section-title {
  margin: 0 0 16px;
}

.grid-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 20px;
}
.grid-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
}
.form-card,
.list-card {
  border: 2px solid #8e44ad;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
}
.list-card {
  margin-top: 12px;
}

label {
  display: block;
  font-size: 12px;
  color: #555;
  margin-top: 8px;
}
input,
select {
  width: 100%;
  padding: 8px;
  margin-top: 6px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f5f5ff;
}
small.hint {
  display: block;
  margin-top: 4px;
  color: #7f8c8d;
}

button {
  width: 100%;
  padding: 10px;
  background: #8e44ad;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 12px;
}
button.secondary {
  background: #5d6d7e;
}
button.danger {
  background: #c0392b;
}
button:hover {
  opacity: 0.92;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.empty {
  color: #7f8c8d;
  font-style: italic;
}

.offer-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #f5f5ff;
  margin-bottom: 10px;
}
.offer-info .title {
  font-weight: 700;
  color: #2c3e50;
}
.offer-info .sub {
  color: #7f8c8d;
  font-size: 12px;
}
.offer-info .msg {
  margin-top: 4px;
}

.row-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.row-actions button {
  width: auto;
  min-width: 110px;
  padding: 8px 12px;
  margin-top: 0;
}
button.ghost {
  background: #5d6d7eaa;
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999; /* أعلى من أي عنصر بالصفحة */
}

.modal {
  display: block; /* تأكيد */
  width: 640px;
  max-width: 95vw;
  background: #fff;
  color: #111; /* تأكيد لون النص */
  border: 2px solid #8e44ad;
  border-radius: 12px;
  padding: 16px;
  min-height: 220px;
  z-index: 100000; /* فوق الخلفية */
}

.modal .empty {
  text-align: center;
  padding: 32px 0;
  font-weight: 600;
}

.modal .sub {
  color: #7f8c8d;
  margin: 4px 0 12px;
}
.modal .empty {
  text-align: center;
  padding: 32px 0;
  font-weight: 600;
}
.winner-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #f5f5ff;
  margin-bottom: 8px;
}
.winner-wallet {
  font-weight: 700;
  color: #2c3e50;
}
</style>
